import { backdropClasses } from "@mui/material/Backdrop";
import type { Components } from "@mui/material/styles";

import type { Theme } from "../types";

export const MuiPopover = {
	defaultProps: { disableScrollLock: true, elevation: 16 },
	styleOverrides: {
		root: {
			[`& .${backdropClasses.root}`]: {
				backdropFilter: "blur(1px)",
			},
		},
		paper: { border: "1px solid var(--mui-palette-divider)" },
	},
} satisfies Components<Theme>["MuiPopover"];
